
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"3.193","fill":"#fff"}}),_c('path',{attrs:{"d":"M12.31 19a2 2 0 012-2h2v4c0 1.656 1.315 3 3 3h4v2c0 1.103-.897 2-2 2h-7a2 2 0 01-2-2v-7zm7 4c-1.104 0-2-.897-2-2v-7a2 2 0 012-2h7a2 2 0 012 2v7c0 1.103-.897 2-2 2h-7z","fill":"#000","fill-opacity":".38"}})])
          )
        }
      }
    